import { createForm } from '../../../factories'

export default createForm(['email', 'role'])



// WEBPACK FOOTER //
// ./src/store/modules/members/forms/store.js